import { useQuery } from "@tanstack/react-query";

import { getProfile } from "../services";

export const useUserProfile = (accessToken?: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ["profile", accessToken],
        queryFn: () => {
            if (!accessToken) throw new Error("No token available");
            return getProfile(accessToken);
        },
        enabled: !!accessToken,
        retry: false,
    });

    return { user: data, isLoading };
};
